import React, { useState, useRef, useCallback } from "react";
import "firebase/firestore";
import { Link } from "@reach/router";

import "@reach/combobox/styles.css";
import FolkSummary from "./FolkSummary";

import styles from "./Home.module.scss";
import Title from "../Non-humans title gif/Title.gif";
import Fox from "../Champions:folk/Fox.gif";
import Pigeon from "../Champions:folk/Birds.gif";
import Frog from "../Champions:folk/Frog.gif";
import Geography from "../Champions:folk/Rivers.gif";
import Tulip from "../Champions:folk/Plants.gif";
import CabbageWhite from "../Champions:folk/Insects.gif";
import Liverbird from "../Champions:folk/liverbird.gif";
import EColi from "../Champions:folk/Bacteria.gif";
import LiverBird from "./LiverBird";
import ShowUsernameButton from "./ShowUsernameButton";
function Home(props) {
  const [tutorialVisible, setTutorialVisible] = React.useState(false);
  const [folk, selectFolk] = React.useState(null);
  const folkArr = [
    {
      name: "bird",
      url: Pigeon,
    },
    {
      name: "water",
      url: Frog,
    },
    {
      name: "mammal",
      url: Fox,
    },
    {
      name: "insect",
      url: CabbageWhite,
    },
    {
      name: "natural feature",
      url: Geography,
    },
    {
      name: "plant",
      url: Tulip,
    },
    // {
    //   name: "bacteria",
    //   url: EColi,
    // },
  ];

  const onFolkClick = (number) => {
    const folkArr = [
      {
        name: "bird",
        url: Pigeon,
      },
      {
        name: "water",
        url: Frog,
      },
      {
        name: "mammal",
        url: Fox,
      },
      {
        name: "insect",
        url: CabbageWhite,
      },
      {
        name: "natural feature",
        url: Geography,
      },
      {
        name: "plant",
        url: Tulip,
      },
      // { name: "bacteria", url: EColi },
    ];
    selectFolk(folkArr[number]);
  };

  return (
    <>
      <div className={styles.container}>
        <div className={styles.left}>
          <div className={styles.center}>
            <h1>
              <img
                className={styles.title}
                src={Title}
                alt="Non-humans of Liverpool"
              />
            </h1>
            <p>
              You are invited to step into the shoes, paws, feet, claws, fins of
              one of the non-human folk in this game. Imagine the city through
              the eyes of a bird, mammal, fish, plant, insect or natural
              feature. What if they had a voice in the city and what would they
              want to say to us or through us? Talk to the Liver Bird to learn
              more!
            </p>
            <br />
          </div>
        </div>
        <div className={styles.right}>
          <img
            src={Liverbird}
            className={styles.liverIcon}
            onClick={() => {
              setTutorialVisible(!tutorialVisible);
            }}
          />
          <p>
            <ShowUsernameButton />
          </p>
          {tutorialVisible && <LiverBird />}
          <h2>SELECT YOUR FOLK</h2>
          <br />
          <div className={styles.FolkSelect}>
            {folkArr.map((folk) => {
              return (
                <img
                  src={folk.url}
                  className={styles.folkIcon}
                  onClick={() => {
                    selectFolk(folk);
                  }}
                ></img>
              );
            })}
          </div>
          {folk !== null ? (
            <FolkSummary alpha={props.alpha} type={folk} />
          ) : null}
        </div>
      </div>
    </>
  );
}

export default Home;
